<template>
    <div>
        <h1>这是Dashboard</h1>
    </div>
</template>
<script>
export default {
    name: "Dashboard"
}
</script>